import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from '@/components/ui/carousel'
import { THomepageCategory } from '@/types/home'
import { CategoryCard } from '../category-card'

type Props = {
  categories: THomepageCategory[]
}

export const CategoryCarousel: React.FC<Props> = ({ categories }) => {
  if (!categories?.length) {
    return (
      <p className='text-center text-neutral-500' role='alert'>
        No categories available.
      </p>
    )
  }

  return (
    <Carousel
      opts={{
        align: 'start',
        duration: 50,
        dragFree: true,
      }}
      className='w-full'
      role='region'
      aria-roledescription='carousel'
    >
      <CarouselContent
        className='carousel-category-section-content -ml-3'
        role='list'
      >
        {categories.map((category, index) => (
          <CarouselItem
            key={category.url}
            className='basis-2/5 pl-3 md:basis-1/3 lg:basis-1/4 xl:basis-1/6'
            role='listitem'
            aria-label={`Category ${index + 1} of ${categories.length}`}
          >
            <CategoryCard
              url={category.url}
              title={category.title}
              image={category.image}
            />
          </CarouselItem>
        ))}
      </CarouselContent>
    </Carousel>
  )
}

// function CarouselNavigation() {
//   return (
//     <>
//       <CarouselPrevious
//         className='absolute -left-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-left-12'
//         variant='black'
//         hideIfStart
//       />
//       <CarouselNext
//         className='absolute -right-4 top-1/2 h-10 w-10 -translate-y-1/2 lg:-right-12'
//         variant='black'
//         hideIfEnd
//       />
//     </>
//   )
// }
